import * as React from 'react';
import {
  EXERCISE_GAP_FILL,
  EXERCISE_GAP_FILL_HINTS,
  EXERCISE_GAP_FILL_QUESTION,
  EXERCISE_GAP_FILL_QUESTION_CONTENT,
  ExerciseGapFillOptions,
} from './types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const ExerciseGapFill = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import('./components/ExerciseGapFill').then((mod) => mod.ExerciseGapFill)
  )
);
const GapFillQuestion = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import('./components/GapFillQuestion').then((mod) => mod.GapFillQuestion)
  )
);
const GapFillQuestionContent = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import('./components/GapFillQuestionContent').then((mod) => mod.GapFillQuestionContent)
  )
);
const Hints = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import('./components/Hints').then((mod) => mod.Hints))
);

export const renderElementExerciseGapFill = (options?: ExerciseGapFillOptions) => (props) => {
  const { element } = props;

  switch (element.type) {
    case EXERCISE_GAP_FILL:
      return <ExerciseGapFill {...props} />;

    case EXERCISE_GAP_FILL_QUESTION:
      return <GapFillQuestion {...props} />;

    case EXERCISE_GAP_FILL_QUESTION_CONTENT:
      return <GapFillQuestionContent {...props} />;

    case EXERCISE_GAP_FILL_HINTS:
      return <Hints {...props} />;

    default:
      return undefined;
  }
};
